import { BaseURl } from "./BaseApiUrl";


//"https://testcockpit.p2k.in/userdetails/getTelecallerList/v1/?userUUID="+ authUser.headers.userUUID + "&isPagination=0&pageNo=0&perPageRec=0"
export const getActiveTelecallerListAPIURL = BaseURl + "userdetails/getTelecallerList/v1/";

//"https://testcockpit.p2k.in/userdetails/getTelecallerList/v1/?userUUID="+ authUser.headers.userUUID + "&isPagination=0&pageNo=0&perPageRec=0"
export const submitManulCallRequestAPIURL = BaseURl + "manualcallrequest/submitmanualcallrequest/v1/";